export const AllInSessionStorage = (superclass) => class extends superclass {

    _setSessionStorageItem(key, value){
        sessionStorage.setItem(key+'_expiry', Date.now() + 900000);
        sessionStorage.setItem(key, value);
    }

    _getSessionStorageItem(key){
        let expiry = sessionStorage.getItem(key+'_expiry');
        if(expiry && Date.now() > expiry){
            sessionStorage.removeItem(key);
            sessionStorage.removeItem(key+'_expiry');
            return null;
        }
        return sessionStorage.getItem(key);
    }

    _checkExpiry(key){
        let expiry = sessionStorage.getItem(key+'_expiry');
        if(expiry && Date.now() > expiry){
            sessionStorage.removeItem(key);
            sessionStorage.removeItem(key+'_expiry');
            return true;
        }
        return false;
    }

    _setExpiry(key, duration=900000){
        sessionStorage.setItem(key+'_expiry', Date.now() + duration);
    }

    _maybeGetLocationsFromSessionStorage(id=null,organisation=null){
        if(!id){
            id = this.currentOrg;
        }
        if(!organisation){
            organisation = this.organisation;
        }
        if(!this._checkExpiry(`allin_org_${id}_locations`)){
            let storedLocations = sessionStorage.getItem(`allin_org_${id}_locations`);
            if(storedLocations){
                organisation.locations = JSON.parse(storedLocations);
                this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(organisation)});
            }
        }
    }

    _maybeGetEventsFromSessionStorage(id=null,organisation=null){
        if(!id){
            id = this.currentOrg;
        }
        if(!organisation){
            organisation = this.organisation;
        }
        if(!this._checkExpiry(`allin_org_${id}_events`)){
            let storedEvents = sessionStorage.getItem(`allin_org_${id}_events`);
            if(storedEvents){
                organisation.events = JSON.parse(storedEvents);
                this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(organisation)});
            }
        }
    }

    _maybeGetProviderEventsFromSessionStorage(organisation=null){
        if(!organisation){
            organisation = this.organisation;
        }
        if(!this._checkExpiry(`allin_org_${this.currentOrg}_provider_events`)){
            let storedEvents = sessionStorage.getItem(`allin_org_${this.currentOrg}_provider_events`);
            if(storedEvents){
                this._events = JSON.parse(storedEvents);
            }
        }
        if(!this._checkExpiry(`allin_org_${this.currentOrg}_provider_event_locations`)){
            let storedEventLocations = sessionStorage.getItem(`allin_org_${this.currentOrg}_provider_event_locations`);
            if(storedEventLocations&&storedEventLocations!='undefined'){
                this._eventsLocations = JSON.parse(storedEventLocations);
            }
        }
    }

    _maybeGetUsersFromLocalStorage(organisation=null){
        if(!organisation){
            organisation = this.organisation;
        }
        if(!this._checkExpiry(`allin_org_${this.currentOrg}_users`)){
        let storedUsers = sessionStorage.getItem(`allin_org_${this.currentOrg}_users`);
            if(storedUsers){
                let orgIndex = this.organisations.findIndex((org)=>org.org_id==this.currentOrg);
                this.organisations[orgIndex].users = storedUsers?JSON.parse(storedUsers):[];
                this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisations:this.organisations});
            }
        }
    }

    _maybeGetMembersFromSessionStorage(members=null){
        if(!members){
            members = this.members;
        }
        let storedMembers = sessionStorage.getItem(`allin_org_${this.currentOrg}_members`);
        if(storedMembers){
            this.members = this.members||{};
            this.members[this.currentOrg] = this.members[this.currentOrg]||{};
            this.members[this.currentOrg] = storedMembers?JSON.parse(storedMembers):{};
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{members:this.members});
        }
    }

    _setMembersToSessionStorage(members=null){
        if(!members){
            members = this.members;
        }
        if(members&&members[this.currentOrg]){
            sessionStorage.setItem(`allin_org_${this.currentOrg}_members`,JSON.stringify(members[this.currentOrg]));
        }
    }

    _setLocationsToSessionStorage(organisation=null){
        if(!organisation){
            organisation = this.organisation;
        }
        if(organisation&&organisation.locations){

            sessionStorage.setItem(`allin_org_${this.currentOrg}_locations`,JSON.stringify(organisation.locations));
            this._setExpiry(`allin_org_${this.currentOrg}_locations`);
        }
    }

    _getProvisionsFromSessionStorage(){
        if(!this._checkExpiry(`allin_org_provisions`)){
            let storedProvisions = sessionStorage.getItem(`allin_org_provisions`);
            if(storedProvisions){
                this.provisions = JSON.parse(storedProvisions);
                this.eventManager.emit(`allin-organisation-${this.name}-update`,{provisions:JSON.stringify(this.provisions)});
            }
        }
    }
    
    _getLocationProvisionsFromSessionStorage(id){
        let loc_id = id? id : this.location.id;
        if(!this._checkExpiry(`allin_location_${loc_id}_provisions`)){
            let storedProvisions = sessionStorage.getItem(`allin_location_${loc_id}_provisions`);
            if(storedProvisions){
                this.location.provisions = JSON.parse(storedProvisions);
                this.eventManager.emit(`allin-location-${this.name}-update`,{location:JSON.stringify(this.location)});
            }
        }
    }
    _getMembershipProvisionsFromSessionStorage(){
        if(!this._checkExpiry(`allin_membership_provisions`)){
            let storedProvisions = sessionStorage.getItem(`allin_membership_provisions`);
            if(storedProvisions){
                this.provisions = JSON.parse(storedProvisions);
                this.eventManager.emit(`allin-membership-${this.name}-update`,{provisions:JSON.stringify(this.provisions)});
            }
        }
    }

    _getEventProvisionsFromSessionStorage(){
        if(!this._checkExpiry(`allin_org_event_provisions`)){
            let storedProvisions = sessionStorage.getItem(`allin_org_event_provisions`);
            if(storedProvisions){
                this.eventProvisions = JSON.parse(storedProvisions);
                this.eventManager.emit(`allin-organisation-${this.name}-update`,{eventProvisions:JSON.stringify(this.eventProvisions)});
            }
        }
    }

    _setEventsToSessionStorage(){
        if(this.organisation&&this.organisation.events){
            sessionStorage.setItem(`allin_org_${this.currentOrg}_events`,JSON.stringify(this.organisation.events));
            this._setExpiry(`allin_org_${this.currentOrg}_events`);
        }
    }

    _setProviderEventsToSessionStorage(){
        sessionStorage.setItem(`allin_org_${this.currentOrg}_provider_events`,JSON.stringify(this._events));
        sessionStorage.setItem(`allin_org_${this.currentOrg}_provider_event_locations`,JSON.stringify(this._eventsLocations));
        this._setExpiry(`allin_org_${this.currentOrg}_provider_events`);
        this._setExpiry(`allin_org_${this.currentOrg}_provider_event_locations`);
    }

    _setProvisionsToSessionStorage(){
        if(this.provisions){
            sessionStorage.setItem(`allin_org_provisions`,JSON.stringify(this.provisions));
            this._setExpiry(`allin_org_provisions`);
        }
    }
    
    _setMembershipProvisionsToSessionStorage(){
        if(this.provisions){
            sessionStorage.setItem(`allin_membership_provisions`,JSON.stringify(this.provisions));
            this._setExpiry(`allin_membership_provisions`);
        }
    }

    _setEventProvisionsSessionStorage(){
        if(this.eventProvisions){
            sessionStorage.setItem(`allin_org_event_provisions`,JSON.stringify(this.eventProvisions));
            this._setExpiry(`allin_org_event_provisions`);
        }
    }

    _setLocationProvisionsToSessionStorage(){
        if(this.location&&this.location.provisions){
            sessionStorage.setItem(`allin_location_${this.location.id}_provisions`,JSON.stringify(this.location.provisions));
            this._setExpiry(`allin_location_${this.location.id}_provisions`);
        }
    }
       
    _setUsersToSessionStorage(){
        let orgIndex = this.organisations.findIndex((org)=>org.org_id==this.currentOrg);
        sessionStorage.setItem(`allin_org_${this.currentOrg}_users`,JSON.stringify(this.organisations[orgIndex].users));
        this._setExpiry(`allin_org_${this.currentOrg}_users`);
    }

}